// extracted by mini-css-extract-plugin
export default {"columnClassName":"src-views-common-components-SDSTable-SDSTable__columnClassName--onR88"};